import React from 'react';
import { User } from 'lucide-react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

const ContactInformation = ({ email, phone, onEmailChange, onPhoneChange, translations }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-6 flex items-center">
        <User className="w-5 h-5 mr-2 text-blue-600" />
        {translations("profile.contactInfo")}
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label htmlFor="email" className="block text-sm font-medium text-gray-700">
          {translations("auth.signup.email")}
          </label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={onEmailChange}
            className="mt-1 block w-full border border-gray-300 rounded-lg shadow-sm p-2.5 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label htmlFor="phone" className="block text-sm font-medium text-gray-700">
          {translations("profile.phone")}
          </label>
          <PhoneInput
            international
            defaultCountry='PT'
            value={phone}
            onChange={onPhoneChange}
            className="mt-1 block w-full border border-gray-300 rounded-lg shadow-sm p-2.5 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
      </div>
    </div>
  );
};

export default ContactInformation;